module.exports = __webpack_public_path__ + "img/mobile-help-3.67ac9a18.jpg";